import React, { useState, useEffect } from "react";
import { useListRefreshListener } from "../../utils/listNavigation";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { callGetRequestNotification, callDeleteRequestNotification, callGetNotificationErrorById } from "../../api/notifications/service";
import CopyrightFooter from "../../components/footer/employers/CopyrightFooter";
import DashboardHeader from "../../components/header/DashboardHeader";
import { encodeBase64, handleGetCookie, FormatCurrencys } from "../../utils/commonUtil";
import DashboardEmployerSidebar from "../../components/header/DashboardSidebar";
import MobileMenu from "../../components/header/MobileMenu";
import RecordsTableFilter from "../../components/table-filter";
import "../../components/i18n/lang";
import { useTranslation } from "react-i18next";
import CustomPagination from "../../components/paginations";
import Swal from "sweetalert2";
import colors from '../../utils/colors';
import { Modal } from 'react-bootstrap';
import SmartTable from "../../components/common/table-component";
import { DocumentPreviewUI } from "../../components/document-preview";

const Notifications = () => {
	let baseUrl = "/admin/notification/save";
	const dispatch = useDispatch();
	const { t } = useTranslation();
	const navigate = useNavigate();
	const [request, setRequest] = useState({ page: 1, maxResult: 10, keyword: '', carriredCode: '', status: '0', id: null, carriredName: '' });
	const [notificationRequest, setNotificationRequest] = useState([]);
	const [totalPages, setTotalPages] = useState(1);
	const [totalRecord, setTotalRecord] = useState(1);
	const [showError, setShowError] = useState(false);

	const [requestError, setRequestError] = useState({ page: 1, maxResult: 10 });
	const [errorNotification, setErrorNotification] = useState([]);
	const [totalErrorPages, setTotalErrorPages] = useState(1);
	const [totalErrorRecord, setTotalErrorRecord] = useState(1);
	const [selectedItem, setSelectedItem] = useState(null);

	useEffect(() => {
		loadData();
		const authData = handleGetCookie('auth');
		if (authData?.user?.userId) {
			setRequest((prev) => ({
				...prev,
				carriredCode: authData?.user?.userId,
				carriredName: authData?.user?.firstName + " " + (authData?.user?.lastName === null ? '' : authData?.user?.lastName),
			}));
		}

	}, [request.page, request.maxResult]);

	const loadData = async () => {
		let data = { page: request.page, maxResult: request.maxResult, keyword: request.keyword };
		const rsp = await dispatch(callGetRequestNotification(data));
		console.log(rsp)
		if (rsp?.payload?.responseCode === "00000") {
			setNotificationRequest(rsp.payload.data.result);
			setTotalPages(rsp.payload.data.totalPages);
			setTotalRecord(rsp.payload.data.totalRecords);
		}
	};

	const handlePageChange = (pageNumber) => {
		if (pageNumber >= 1 && pageNumber <= totalPages) {
			setRequest((prev) => ({ ...prev, page: pageNumber }));
		}
	};

	const handleChange = (e) => {
		setRequest((prev) => ({ ...prev, keyword: e.target.value }));
	};

	const onSearch = async (e) => {
		e.preventDefault();
		loadData();
	};

	const handlePageChangeError = (pageNumber) => {
		if (pageNumber >= 1 && pageNumber <= totalErrorPages) {
			setRequestError((prev) => ({ ...prev, page: pageNumber }));
		}
	};

	const handleShowError = async (item) => {
		setSelectedItem(item.title)
		let data = { page: request.page, maxResult: request.maxResult, id: item.id };
		const rsp = await dispatch(callGetNotificationErrorById(data));
		console.log(rsp)
		if (rsp?.payload?.responseCode === "00000") {
			setErrorNotification(rsp.payload.data.result);
			setTotalErrorPages(rsp.payload.data.totalPages);
			setTotalErrorRecord(rsp.payload.data.totalRecords);

			setShowError(true)

		}
	}

	const handleClose = () => {
		setShowError(false)
	}


	const handleDeleteNotification = (id) => {
		Swal.fire({
			title: t("confirm"),
			text: t("notification.cancel") + " ?",
			icon: "warning",
			reverseButtons: true,
			showCancelButton: true,
			confirmButtonColor: colors.confirmMessage,
			cancelButtonColor: colors.cancel,
			confirmButtonText: t('confirm'),
			cancelButtonText: t('cancel')
		}).then(async (result) => {
			if (result.isConfirmed) {
				let data = {
					id: id,
					carriredCode: request.carriredCode,
					carriredName: request.carriredName,
				}
				const rsp = await dispatch(callDeleteRequestNotification(data));
				if (rsp?.payload?.responseCode === "00000") {
					Swal.fire({
						icon: "success",
						title: t("success.cancel"),
						confirmButtonColor: colors.confirmMessage,
						confirmButtonText: t('close'),
					}).then(() => {
						window.location.reload()
					});
				}
			}
		});

	};

	useListRefreshListener(loadData);

	return (
		<div className="page-wrapper dashboard">
			<span className="header-span"></span>
			<DashboardHeader />
			<MobileMenu />
			<DashboardEmployerSidebar />
			<section className="user-dashboard">
				<div className="dashboard-outer">
					<div className="upper-title-box">
						<h4>{t("menu.notification.name")}</h4>
						<div className="group-button-header">
							<button type="button" className="btn btn-primary" onClick={() => navigate(baseUrl)}>
								<i className="fas fa-plus"></i> {t("button.add")}
							</button>
						</div>
					</div>

					<div className="row">
						<div className="col-12">
							<div className="ls-widget">
								<div className="tabs-box">
									<div className="widget-content p-4">
										<div className="default-form">
											<div className="row">
												<div className="col-md-3">
													<div className="form-group">
														<label>{t('search.keyword')}</label>
														<input
															type="text"
															name="keyword"
															className="form-control-uld"
															placeholder={t('search.keyword') + "..."}
															onChange={handleChange}
															value={request.keyword}
															autoComplete="off"
														/>
													</div>
												</div>
												<div className="col-auto auto-button">
													<label style={{ marginTop: 6 }}>&nbsp;</label>
													<button className="theme-btn btn-style-one w-100" onClick={onSearch}>
														<i className="fas fa-search"></i>&nbsp;{t("button.search")}
													</button>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div className="row">
						<div className="col-12">
							<div className="ls-widget">
								<div className="tabs-box">
									<div className="widget-content p-4">
										<RecordsTableFilter
											totalRecord={totalRecord}
											perPage={request.maxResult}
											onChange={(e) =>
												setRequest((prev) => ({
													...prev,
													maxResult: Number(e.target.value),
													page: 1,
												}))
											}
										/>

										<SmartTable
											columns={[
												{ labelKey: "notification.id", key: "id" },
												{ labelKey: "notification.title", key: "title" },
												{ labelKey: "notification.body", key: "body" },
												{ labelKey: "notification.description", key: "description" },
												{ labelKey: "notification.notiType", key: "notiType", render: (val) => val == 3 ? t('notification.type.normal') : val == 6 ? t('notification.type.life') : val == 0 ? t('notification.type.all') : t('notification.type.vehicle') },
												{ labelKey: "notification.totalSuccess", key: "totalSuccess", className: "text-success", render: (val) => FormatCurrencys(val) },
												{ labelKey: "notification.totalFailure", key: "totalFailure", className: "text-danger", render: (val) => FormatCurrencys(val) },
												{ labelKey: "notification.image", key: "imgPath", render: (val) => val ? <DocumentPreviewUI documents={val} /> : '-' },
											]}
											data={{ result: notificationRequest }}
											rowKey="id"
											recordsTableFilter={false}
											customPagination={false}
											showRowNumber={false}
											actions={(item) => (
												<div>
													<button className="btn btn-success btn-sm" onClick={() => handleShowError(item)}><i className="fas fa-search"></i></button>
													&nbsp;
													<button className="btn btn-danger btn-sm" onClick={() => handleDeleteNotification(item.id)}><i className="fas fa-trash"></i></button>
												</div>
											)}
										/>

										<CustomPagination
											currentPage={request.page}
											totalPages={totalPages}
											onPageChange={handlePageChange}
											maxVisiblePages={1}
										/>
									</div>
								</div>
							</div>
						</div>
					</div>


					<Modal show={showError} onHide={handleClose} size="xl">
						<Modal.Header closeButton>
							<Modal.Title>
								{
									selectedItem
								}
							</Modal.Title>
						</Modal.Header>
						<Modal.Body>
							<div className="ls-widget">
								<div className="tabs-box">
									<div className="widget-content p-3">
										<RecordsTableFilter
											totalRecord={totalErrorRecord}
											perPage={requestError.maxResult}
											onChange={(e) =>
												setRequestError((prev) => ({
													...prev,
													maxResult: Number(e.target.value),
													page: 1,
												}))
											}
										/>

										<SmartTable
											columns={[
												{ labelKey: "notification.userId", key: "userId" },
												{ labelKey: "notification.firstName", key: "firstName" },
												{ labelKey: "notification.lastName", key: "lastName" },
												{ labelKey: "notification.cause", key: "errorDescription" },
											]}
											data={{ result: errorNotification }}
											rowKey="id"
											recordsTableFilter={false}
											customPagination={false}
											showRowNumber={true}
											rowNumberOffset={(requestError.page - 1) * requestError.maxResult}
										/>

										<CustomPagination
											currentPage={requestError.page}
											totalPages={totalErrorPages}
											onPageChange={handlePageChangeError}
											maxVisiblePages={1}
										/>
									</div>
								</div>
							</div>
						</Modal.Body>
					</Modal>

				</div>
			</section>
			<CopyrightFooter />
		</div>
	);
};

export default Notifications;
